import { MAX_SEARCH_DAYS } from '../dailyCloseShared/constants'

export const SCREEN_TITLE = '일마감조회(상품별) 2.0'

// RP12·RP13 공통 값은 dailyCloseShared/constants.ts 한 곳에 둔다.
export { DATE_PARAM_FORMAT, DETAIL_DEFAULT_PAGE_SIZE, DETAIL_MAX_PAGE_SIZE, DETAIL_MID_PAGE_SIZE, MAX_SEARCH_DAYS } from '../dailyCloseShared/constants'

export const FIELD_NAMES = {
  shipperCode: 'shipperCode',
  closeDateRange: 'closeDateRange',
  brandName: 'brandName',
  goodsCode: 'goodsCode',
  barcodes: 'barcodes',
  logisticsServiceType: 'logisticsServiceType',
} as const

export const MESSAGES = {
  closeDateRequired: '마감일자를 선택해 주세요.',
  closeDateInvalidRange: '마감일자 시작일이 종료일보다 늦습니다.',
  closeDatePeriodExceeded: `조회 기간은 최대 ${MAX_SEARCH_DAYS}일까지 가능합니다.`,
  shipperOrServiceTypeRequired: '화주 또는 물류서비스타입 중 하나를 선택해 주세요.',
} as const
